
import { useRoute, useRouter} from 'vue-router'
import { toRefs, defineComponent, reactive, getCurrentInstance } from 'vue'
import { VueDraggableNext } from 'vue-draggable-next'
import { BrandCat } from '@/enums/brand'
import { joinParams } from '@/utils/index'

export default defineComponent({
name: 'EditCouponLots',
components: {
    draggable: VueDraggableNext
},

setup () {
    const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const route = useRoute()

    const state = reactive({
        t:  route.query.t,  // 页面展示状态
        check_type: route.query.check_type || '', // check_type=1时,表示是由商户端审核列表进入
        product_id: route.query.id || '', // 主商品ID
        relevance_id:       '', // 推荐商品ID
        productInfo:        {}, // 主商品信息
        currRecommend:      '', // 当前操作推荐商品信息
        recommendList:      [], // 推荐商品列表
        tableData:          [], // 推荐列表数据
    })

    /**
     * 根据商品ID获取商品详情
     * type：1-获取主商品详情，2-获取推荐商品详情
     * product_id：当获取主商品时为主商品ID，当获取推荐商品中时为推荐商品ID（此时，relevance_id 为主商品ID）
     * index：用于获取回显数据后更新 tableData 对应索引项的值
    */
    const getProductInfo = (product_id, type = 1, relevance_id = '', index = -1) => {
        if (!product_id) {
            return
        }
        if (type == 2 && !relevance_id) {
            return proxy.$message({ type: 'warning', message: '请先输入主商品ID' })
        }
        proxy.$http.post(`/product/product_info_list?${joinParams({product_id, type, relevance_id})}`).then(res => {
            const {code, data, msg} = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            if (data) {
                if (relevance_id) {
                    data.product_id = data.id
                    // @ts-ignore
                    state.tableData[index] = data
                } else {
                    state.productInfo = data
                }
            } else {
                proxy.$message({ type: 'error', message: '推荐商品ID有误，请重新输入' })
            }
        })
    }
    // 向推荐列表中添加一行
    const onAdd = () => {
        let row = {
            product_id: '',
            title:      '',
            price:      '',
            image_path: ''
        }
        // @ts-ignore
        state.tableData.push(row)
    }
    // 删除一行
    const onDel = (row, index) => {
        const { id } = row
        proxy.$confirm(`确定要删除该商品吗？`, '提示', {
            type: 'warning'
        }).then(() => {
            if (id) {
                proxy.$http.post('/product/relevance_product_del', {del_id: id}).then(res => {
                    const {code, msg} = res
                    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                    proxy.$message({ type: 'success', message: '删除成功' })
                    state.tableData.splice(index, 1)
                })
            } else {
                state.tableData.splice(index, 1)
            }
        }).catch(() => {
            console.log('取消删除')
        })
    }
    // 保存
    const onSave = () => {
        const { tableData, product_id } = state
        let product_data = <any>[]
        tableData.map(item => {
            // @ts-ignore
            if (item.title) { // 当获取到商品详情时才进行保存
                product_data.push({
                    relevance_id: product_id,
                    // @ts-ignore
                    product_id: item.product_id
                })
            }
        })
        proxy.$http.post('/product/relevance_product_add', {product_data, relevance_id:route.query.id}).then(res => {
            const {code, data, msg} = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            proxy.$message({ type: 'success', message: '保存成功' })
            setTimeout(() => {
                router.go(-1)
            }, 2000)
        })
    }
    // 获取反显数据
    if (state.product_id) {
        proxy.$http.get(`/product/relevance_product_details?relevance_id=${state.product_id}`).then(res => {
            const {code, data, msg} = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            state.productInfo = data.products
            state.tableData = data.relevance_product
        })
    }

    return { ...toRefs(state), BrandCat, router, route, onAdd, onSave, onDel, getProductInfo }
}
})
